import React from "react";
import get from "lodash/get";

import sortPrograms from "../../../utils/sort-programs";

import BuildProgramStepOneModal from "../../../parts/modals/add-cycle";
import BuildProgramStepTwoModal from "../common-components/cp-program-settings";
import LearnMoreModal from "../../../parts/modals/learn-more";
import EditProgramSettingsModal from "../../../parts/modals/edit-program-settings";
import AllTemplates from "./AllTemplates";
import { getRoleNameById } from "../../dashboard/settings/manage-coaches/utils/manage-coaches-utils";

import { filterByPath, filterCyclesByPath } from "../../../utils/array-helpers";
import SendModal from "../common-components/SendModal";
import FetchModal from "../common-components/FetchModal";
import { fetchSendProjection } from "../../../utils/projection-helpers";
import ActivityDrawer from "../../../parts/activity-drawer/ActivityDrawer";
import CopyMealPlanFromModal from "./modals/CopyMealPlanFromModal";
import CopyMealPlanToModal from "./modals/CopyMealPlanToModal";
import HandleMealPlanTemplateModal from "./modals/HandleMealPlanTemplateModal";

const pageSize = 40;

const AllTemplatesController = async ({ res, req, locals, load }) => {
  const { query = {} } = req;
  const proxyAthlete = query.athlete;
  const page = query.page - 1 || 0;
  const modal = get(query, "modal", {});
  const organizationRoles = locals.organizationRoles || [];
  //Get the name of the organization's role of the current user
  const organizationRoleName = locals.activeUser.organizationRoleId
    ? getRoleNameById(organizationRoles, locals.activeUser.organizationRoleId)
    : "Coach";
  //The user is allow to see al the athletes of the coaches
  const isAllowToViewAllOrganizationsAthletes =
    organizationRoleName === "Owner" || organizationRoleName === "Admin";

  const loadPromises = [];
  if (query["owner"] === "coach") {
    loadPromises.push(
      load("athleteCycles", {
        customLimit: pageSize,
        customSkip: pageSize * page,
        owner: locals.activeUserToRequest._id,
      }),
      load("athleteCyclesCount", locals.activeUserToRequest._id),
      load("mealPlanTemplates", {
        customLimit: pageSize,
        customSkip: pageSize * page,
        noPagination: false,
      }),
      load("mealPlanCount")
    );
  } else {
    loadPromises.push(
      load("athleteCycles", {
        customLimit: pageSize,
        customSkip: pageSize * page,
      }),
      load("athleteCyclesCount")
    );
  }

  switch (modal.type) {
    case "edit-cycle-settings":
    case "edit-program-settings":
      loadPromises.push(
        load("editCycle", { cycle: query.cycleId, proxyAthlete })
      );
      break;
    case "learn-more":
      loadPromises.push(
        load("editCycle", { cycle: query.cycleId }),
        load("programExercises", { programId: query.cycleId })
      );
      break;
    case "send":
      loadPromises.push(
        load("athleteCycles", { customProjection: fetchSendProjection }),
        load("allAthletesFromOrganization")
      );
      if (query.recipient)
        loadPromises.push(load("unPushedAthleteCyclesNames", query.recipient));
      break;
    case "fetch":
      loadPromises.push(
        load("allAthletesFromOrganization"),
        load("copiableCycles", {})
      );
      break;
    case "copy-meal-plan-to":
      loadPromises.push(
        load("allAthletesFromOrganization"),
        load("assignedMealPlans")
      );

      break;
    case "copy-meal-plan-from":
      loadPromises.push(
        load("mealPlanTemplates", {
          customLimit: 1,
          customSkip: 1,
          noPagination: true,
        }),
        load("allAthletesFromOrganization"),
        load("assignedMealPlans")
      );
      break;
    default:
      break;
  }

  await Promise.all(loadPromises);

  locals.modal = {
    "build-step-one": <BuildProgramStepOneModal />,
    "build-step-two": <BuildProgramStepTwoModal />,
    "edit-cycle-settings": <BuildProgramStepOneModal />,
    "edit-program-settings": <EditProgramSettingsModal />,
    "learn-more": <LearnMoreModal />,
    fetch: (
      <FetchModal
        isAllowToViewAllOrganizationsAthletes={
          isAllowToViewAllOrganizationsAthletes
        }
      />
    ),
    send: (
      <SendModal
        isAllowToViewAllOrganizationsAthletes={
          isAllowToViewAllOrganizationsAthletes
        }
      />
    ),
    "activity-feed": <ActivityDrawer />,
    "copy-meal-plan-from": <CopyMealPlanFromModal locals={locals} />,
    "copy-meal-plan-to": <CopyMealPlanToModal locals={locals} />,
    "handle-meal-plan": <HandleMealPlanTemplateModal locals={locals} />,
  }[modal.type];

  query.sort = query.sort || "createdDate";
  locals.cards = sortPrograms(
    locals.athleteCycles,
    query.sort,
    query["program-type"],
    query["program-progress"],
    query["program-view"],
    query["owner"]
  );

  locals.cards =
    query["program-view"] === "programs"
      ? filterByPath(locals.cards, query.filters)
      : filterCyclesByPath(locals.cards, query.filters, true);

  res.body = (
    <AllTemplates
      total={locals.athleteCyclesCount.count}
      query={query}
      pageSize={pageSize}
    />
  );
};

export default AllTemplatesController;